import { render, staticRenderFns } from "./GlobalSoftphone.vue?vue&type=template&id=f8fed2a6&"
import script from "./GlobalSoftphone.vue?vue&type=script&lang=js&"
export * from "./GlobalSoftphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports